/* eslint-disable react/self-closing-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  SEARCH_TOUR,
  WHO_GO_LABEL,
  WHEN_LABEL,
  NIGHTS_LABEL,
  WHEN_ID,
  TOURISTS_ID,
  NIGHTS_ID,
  TO_LABEL,
  TO_ID,
  HOTEL_LABEL,
  HOTEL_ID,
  FROM_LABEL,
  FROM_ID,
} from '../../../Utils/Constants/HomePageConstants';
import { HOTEL_DETAILS } from '../../../Utils/Constants/GlobalConstants';
import {
  changeCharterOnly,
  changeSelectedResorts,
} from '../../../DataStore/actions/searchFormActions';
import {
  changeSelectedHotels,
  changeIsAllRegionsFilterTab,
} from '../../../DataStore/actions/FiltersAction';
import {
  firstLetterInUpperCase,
  getShortString,
} from '../../../Utils/CommonUtils';
import './css/TabletSearchForm.css';
import { ReactComponent as Calendar } from '../../../images/calendar-r.svg';
import { ReactComponent as Arrow } from '../../../images/arrow-bottom-black-r.svg';
import Input from '../Input/Input';

const mapStateToProps = (state) => ({ ...state });

class TabletSearchForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { isDisabled, page, hotel, handleSubmit } = this.props;

    return (
      <div className="sf_t_wrap">
        <div className="sf_t_line">
          <div className="sf_t_item light_gray_button">
            <Input label={FROM_LABEL} id={FROM_ID} />
          </div>
          <div className="sf_t_delimeter"></div>
          <div className="sf_t_item light_gray_button">
            {page === HOTEL_DETAILS ? (
              <Input
                label={HOTEL_LABEL}
                id={HOTEL_ID}
                value={getShortString(firstLetterInUpperCase(hotel), 28)}
              />
            ) : (
              <Input label={TO_LABEL} id={TO_ID} />
            )}
          </div>
        </div>
        <div className="sf_t_line">
          <div className="sf_t_item sf_t_calendar_item light_gray_button">
            <Input label={WHEN_LABEL} id={WHEN_ID} ico={<Calendar />} />
          </div>
          <div className="sf_t_delimeter"></div>
          <div className="sf_t_item light_gray_button">
            <Input label={NIGHTS_LABEL} id={NIGHTS_ID} />
          </div>
          <div className="sf_t_delimeter"></div>
          <div className="sf_t_item light_gray_button">
            <Input label={WHO_GO_LABEL} id={TOURISTS_ID} ico={<Arrow />} />
          </div>
        </div>
        <button
          type="button"
          className="sf_t_search bm_text_18"
          onClick={handleSubmit}
          disabled={isDisabled}
        >
          {SEARCH_TOUR}
        </button>
      </div>
    );
  }
}

TabletSearchForm.propTypes = {
  isDisabled: PropTypes.bool,
  page: PropTypes.string.isRequired,
  hotel: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
};

TabletSearchForm.defaultProps = {
  isDisabled: false,
  hotel: '',
};

export default connect(mapStateToProps, {
  changeCharterOnly,
  changeSelectedHotels,
  changeSelectedResorts,
  changeIsAllRegionsFilterTab,
})(TabletSearchForm);
